import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgMudslide(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="3 -4 18 24" {...props}>
      <path
        d="M20.092 9.106a.748.748 0 01-.442.065c-.332-.052-.59-.374-.59-.734V7.075c0-.874-.754-1.584-1.68-1.584s-1.68.71-1.68 1.584v4.04a.657.657 0 01-.252.513.747.747 0 01-.587.152c-.332-.052-.591-.374-.591-.734V5.094c0-.874-.754-1.584-1.68-1.584h-.795c-.347 0-.628.265-.628.592v.443a.661.661 0 01-.252.514.756.756 0 01-.589.15c-.331-.05-.59-.371-.59-.732v-.139a.604.604 0 00-.52-.584 1.943 1.943 0 01-.888-.369c-.421-.32-.588-.447-1.162-.357a.603.603 0 00-.525.585v5.933c0 .372-.321.675-.715.675-.396 0-.716-.303-.716-.675V4.672a.59.59 0 00-.362-.536c-.22-.098-.86-.065-1.048.08-.508.4-.8.99-.8 1.619v6.357c0 .757.437 1.463 1.14 1.84a2.191 2.191 0 002.117 0c.107-.06.213-.126.315-.2.263-.19.664-.279.969-.048.563.427 1.265.658 2.063.667a3.34 3.34 0 001.866-.61c.27-.191.685-.28 1.001-.042.559.418 1.254.645 2.009.656h.009a.656.656 0 00.087-.007 3.331 3.331 0 001.806-.607c.3-.216.76-.212 1.072.01.095.067.192.127.288.181a2.197 2.197 0 002.119 0c.702-.378 1.139-1.083 1.139-1.84V9.636a.586.586 0 00-.297-.504.662.662 0 00-.61-.026z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Mudslide')(SvgMudslide);
